import { getNewsletterClient } from '../../../services/newsletterClient';

export const NEWSLETTER_CONSENT_TEXT = 'I agree to receive the GameHearts newsletter by email.';
export const NEWSLETTER_CONSENT_REQUIRED = 'Please tick the box to receive the newsletter.';
export const NEWSLETTER_SUCCESS_MESSAGE = 'Thanks. Please check your email to confirm your subscription.';
export const NEWSLETTER_FAILURE_MESSAGE = 'Failed to subscribe to the newsletter. Please try again later.';

export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const newsletterErrorMessage = (error: unknown): string => {
  if (error instanceof Error && error.message === NEWSLETTER_CONSENT_REQUIRED) {
    return NEWSLETTER_CONSENT_REQUIRED;
  }

  return NEWSLETTER_FAILURE_MESSAGE;
};

export const subscribeToNewsletter = async (
  email: string,
  options: { consent: boolean; honeypot?: string }
): Promise<string> => {
  if (!options.consent) {
    throw new Error(NEWSLETTER_CONSENT_REQUIRED);
  }

  const client = getNewsletterClient();
  if (!client) {
    throw new Error(NEWSLETTER_FAILURE_MESSAGE);
  }

  await client.subscribe({
    email,
    consent: true,
    honeypot: options.honeypot ?? '',
  });

  return NEWSLETTER_SUCCESS_MESSAGE;
};
